const _load = () => import(/* webpackChunkName: "polyfills/load" */'./load')

if (!('fetch' in window)) {
  _load()
}
